import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { PaymentDueFinance} from '../component/DatePicker';
import moment from 'moment';
import { KEY_PAYMENT_ACTIVE_TAB_MAP } from '../../src/config/constant';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
import { useLanguage } from '../../src/context/LanguageContext';
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: number;
  label: string;
};


const PaymentFilter = (props: any) => {
    const { submitHandler, selectedFilters, setSelectedFilters, config, insurerList,assign_user_id } = props;
    const [showDueRange, setShowDueRange] = useState<any>(false);
    const {translations} = useLanguage();
    const [errorState, setErrorState] = useState<any>({
        start_date: '',
        end_date: '',
    });

    // const handleChange_old = (selectedOption: any, key: string) => {
    //     let value: any = null;
    //     let updatedErrors = { ...errorState };

    //     if (key === 'created_on' || key === 'start_date' || key === 'end_date') {
    //         value = moment(selectedOption).format('YYYY-MM-DD');

    //         // Validate start_date if end_date exists
    //         if (key === 'start_date' && selectedFilters.end_date) {
    //             if (moment(value).isAfter(selectedFilters.end_date)) {
    //                 updatedErrors.start_date = "Start date must be less.";
    //             } else {
    //                 updatedErrors.start_date = '';
    //             }
    //         }

    //         // Validate end_date if start_date exists
    //         if (key === 'end_date' && selectedFilters.start_date) {
    //             if (moment(value).isBefore(selectedFilters.start_date)) {
    //                 updatedErrors.end_date = "End date must be greater.";
    //             } else {
    //                 updatedErrors.end_date = '';
    //             }
    //         }
    //     } else if (key === 'searchKeyword') {
    //         value = selectedOption.target.value;
    //     } else {
    //         value = selectedOption.value;
    //     }

    //     if (!updatedErrors.start_date && !updatedErrors.end_date) {
    //         setSelectedFilters((prev: any) => ({
    //             ...prev,
    //             [key]: value
    //         }));
    //     }

    //     setErrorState(updatedErrors);
    // };

    const handleChange = (selectedOption: any, key: string) => {
        setSelectedFilters((prev: any) => {
          let updatedFilters = { ...prev };
          let updatedErrors = { ...errorState };  
          if (key === 'created_on' || key === 'start_date' || key === 'end_date' || key === 'due_date') {
            if (key === 'due_date') {
              if (selectedOption.length === 2) {
                updatedFilters["due_from_date"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                updatedFilters["due_to_date"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
              } else {
                updatedFilters["due_from_date"] = selectedOption[0]?.format("YYYY-MM-DD");
                updatedFilters["due_to_date"] = null;
              }
            } else {
                let value = selectedOption ? moment(selectedOption).format('YYYY-MM-DD') : null;
               // Validate start_date if end_date exists
                if (key === 'start_date' && selectedFilters.end_date) {
                    if (moment(value).isAfter(selectedFilters.end_date)) {
                        updatedErrors.start_date = "Start date must be less.";
                    } else {
                        updatedErrors.start_date = '';
                    }
                }

                // Validate end_date if start_date exists
                if (key === 'end_date' && selectedFilters.start_date) {
                    if (moment(value).isBefore(selectedFilters.start_date)) {
                        updatedErrors.end_date = "End date must be greater.";
                    } else {
                        updatedErrors.end_date = '';
                    }
                }  
              updatedFilters[key] = selectedOption ? moment(selectedOption).format('YYYY-MM-DD') : null;
            }
          } else if (key === 'searchKeyword') {
            updatedFilters[key] = selectedOption.target.value;
          } else if (key === 'payment_due') {
            if (selectedOption?.value === 'custom') {
              setShowDueRange(true);
            } else {
              if (selectedOption?.value === 'next_7_days') {
                updatedFilters['due_from_date'] = moment().format("YYYY-MM-DD");
                updatedFilters['due_to_date'] = moment().add(7, "days").format("YYYY-MM-DD");
              } else if (selectedOption?.value === 'next_14_days') {
                updatedFilters['due_from_date'] = moment().format("YYYY-MM-DD");
                updatedFilters['due_to_date'] = moment().add(14, "days").format("YYYY-MM-DD");
              } else if (selectedOption?.value === 'this_month') {
                updatedFilters['due_from_date'] = moment().startOf("month").format("YYYY-MM-DD");
                updatedFilters['due_to_date'] = moment().endOf("month").format("YYYY-MM-DD");
              }
              setShowDueRange(false);
            }
            updatedFilters[key] = selectedOption?.value || null;
          }else if (selectedOption instanceof Array){
            // For multi-select (array of options)
            updatedFilters[key] = selectedOption.map((e) => e.value);
          } else {
            updatedFilters[key] = selectedOption?.value || null;
          }
          setErrorState(updatedErrors);
          return updatedFilters;
        });
    };

    /**
    * FILTER SET HANDLER
    */
    const onFilterSearch = () => {
        if (!errorState.start_date && !errorState.end_date && Object.keys(selectedFilters).length) {
            submitHandler({ page_number: 1, ...selectedFilters });
        }
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        if(Object.keys(selectedFilters).length){
            setSelectedFilters({});
            submitHandler({ page_number: 1, activeTab: KEY_PAYMENT_ACTIVE_TAB_MAP['first'] });
        }
    }

    return (
        <React.Fragment>
            <div className="lead-list-filter finance-filter">
                <div className="filter-filed-form">
                    {filters.paymentFilters(translations).map((filter: any) => renderFilterField(filter, { selectedFilters, handleChange, translations,CustomValueContainer,
                      options:{
                          insurerList: insurerList, 
                          payment_due_in: config?.payment_due_in,
                          lead_types: config?.lead_types,
                          assigning_filters:config?.assigning_filters,
                          assign_user_id:assign_user_id
                      },
                      showDueRange
                    }))}
                    {/* <fieldset className="search-bx">
                    <div className="material">
                        <input
                        type="text"
                        placeholder="Search by Policy No, Customer..."
                        name="search"
                        className="form-input"
                        aria-label="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
                        title="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
                        onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""} 
                        />
                        <i className="ic-search"></i>
                    </div>
                    </fieldset> */}
                    {/* <fieldset className="date-filed">
                        <div className="material">
                            <CreatedDate selectedFilters={selectedFilters} handleChange={handleChange}/>
                        </div>
                    </fieldset>
                    <fieldset className="">
                        <div className="material">
                            <StartDate selectedFilters={selectedFilters} handleChange={handleChange}/>
                            {errorState.start_date && <span  className = ""style={{ color: 'red' }}>{errorState.start_date}</span>} 
                        </div>
                    </fieldset>
                    <fieldset className="">
                        <div className="material">
                            <EndDate selectedFilters={selectedFilters} handleChange={handleChange}/>
                            {errorState.end_date && <span  className = ""style={{ color: 'red' }}>{errorState.end_date}</span>} 
                        </div>
                    </fieldset> */}
                    {/* <fieldset className="single-select">
                        <div className="material">
                            <Select<OptionType>
                                components={{ ValueContainer: CustomValueContainer }}
                                options={attachmentFilterList}
                                placeholder="Attachment"
                                className="react-select"
                                classNamePrefix="react-select"
                                isClearable
                                onChange={(e: any) => handleChange(e, 'attachment')}
                                value={attachmentFilterList.find((option) => option.value === selectedFilters.attachment) || null}
                            />
                        </div>
                    </fieldset> */}
                     {/* <fieldset className="single-select">
                    <div className="material">
                        <Select<OptionType>
                        components={{ ValueContainer: CustomValueContainer }}
                        options={insurerList}
                        placeholder="Insurer Name"
                        className="react-select"
                        classNamePrefix="react-select"
                        isClearable
                        onChange={(e: any) => handleChange(e, 'insured_id')}
                        value={insurerList?.find((option: any) => option.value === selectedFilters.insured_id) || null}
                        />
                    </div>
                    </fieldset> */}
                    
                    {/* <fieldset className="single-select">
                        <div className="material">
                            <Select<OptionType>
                                components={{ ValueContainer: CustomValueContainer }}
                                options={PaymentMethodList}
                                placeholder="Method"
                                className="react-select"
                                classNamePrefix="react-select"
                                isClearable
                                onChange={(e: any) => handleChange(e, 'method')}
                                value={PaymentMethodList.find((option: any) => option.value === selectedFilters.method) || null}
                            />
                        </div>
                    </fieldset> */}
                    {/* <fieldset className="single-select">
                    <div className="material">
                        <Select<OptionType>
                        components={{ ValueContainer: CustomValueContainer }}
                        options={config['payment_due_in']}
                        placeholder="Payment Due In"
                        className="react-select"
                        classNamePrefix="react-select"
                        isClearable
                        onChange={(e: any) => handleChange(e, 'payment_due')}
                        value={config['payment_due_in']?.find((option: any) => option.value === selectedFilters.payment_due) || null}
                        />
                    </div>
                    </fieldset> */}
                    {/* {
                    showDueRange && 
                    <fieldset className="date-filed">
                        <div className="material">
                        <PaymentDueFinance selectedFilters={selectedFilters} handleChange={handleChange}/>
                        </div>
                    </fieldset>
                    } */}
                    <div className="btn-submit-reset">
                        <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                        <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                    </div>
                </div>
                

            </div>
        </React.Fragment>
    )
}


export default PaymentFilter;

